export default "__VITE_ASSET__CP4Iq5WG__"